export const ANNOUNCEMENTS_GET = 'ANNOUNCEMENTS_GET';
export const ANNOUNCEMENT_ADD = 'ANNOUNCEMENT_ADD';
export const ANNOUNCEMENT_EDIT = 'ANNOUNCEMENT_EDIT';
export const ANNOUNCEMENT_GET = 'ANNOUNCEMENT_GET';
export const ANNOUNCEMENT_UPLOADFILE = 'ANNOUNCEMENT_UPLOADFILE';
export const ANNOUNCEMENT_DELETE = 'ANNOUNCEMENT_DELETE';
